import { library } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'

// Don't add Font Awesome CSS automatically
library.add(far, fas, fal)

export default defineNuxtPlugin((nuxtApp) => {
  // Register the Font Awesome components
  nuxtApp.vueApp.component('FontAwesome', FontAwesomeIcon)
  nuxtApp.vueApp.component('FontAwesomeLayers', FontAwesomeLayers)
})
